import { combineReducers } from 'redux';
import captchaReducer from './Captcha';
import companyReducer from './Company';
import complaintPositionReducer from './ComplaintPosition';
import complaintPositionsRecuder from './ComplaintPositions';
import complaintReducer from './Complaint';
import complaintPositionsComponentsReducer from './ComplaintPositionsComponents';
import createComplaintMenuReducer from './CreateComplaintMenu';
import customerReducer from './Customer';
import errorReducer from './Error';
import fileReducer from './File';
import initialDataReducer from './InitialData';
import modalReducer from './Modal';
import notificationReducer from './Notification';
import pageReducer from './Page';
import productReducer from './Products';
import utilReducer from './Util';
import textsReducer from './Texts';
import waybillDataReducer from './WaybillData';

import createComplaint from './CreateComplaint';

const allReducers  = combineReducers({
    captcha: captchaReducer,
    company: companyReducer,
    complaint: complaintReducer, 
    complaintPosition: complaintPositionReducer,
    complaintPositions: complaintPositionsRecuder,
    complaintPositionsComponents: complaintPositionsComponentsReducer,
    createComplaintMenu: createComplaintMenuReducer,
    customer: customerReducer,
    error: errorReducer,
    file: fileReducer,
    initialData: initialDataReducer,
    modal: modalReducer,
    notification: notificationReducer,
    page: pageReducer, 
    product: productReducer,
    texts:textsReducer,
    util: utilReducer,
    waybillData: waybillDataReducer,
    createXLComplaint:createComplaint
});

export default allReducers;


// WEBPACK FOOTER //
// ./src/reducers/Index.js